import { render, staticRenderFns } from "./app-logs.vue?vue&type=template&id=2f62c74a&"
import script from "./app-logs.vue?vue&type=script&lang=js&"
export * from "./app-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports